import { useCallback } from 'react';
import { getMessageFromActions } from 'js/hooks/server';
import { LAYER, useSmartClosePopups } from 'js/components/common/PopupManager';
import { useTwoFactorAuthenticationPopup } from 'js/components/popups/TwoFactorAuthenticationPopup';

import { useLogout } from '../../useLogout';
import { VALIDATION_TYPE } from '../constants';
import { resendLogin2FAToken } from '../../../pas';
import { useContinueLogin } from './useContinueLogin';
import { useValidationManager } from './useValidationManager';

export const useValidate2FA = (validationsRef) => {
    const logout = useLogout();
    const continueLogin = useContinueLogin();
    const closePopups = useSmartClosePopups();
    const showTwoFactorAuthenticationPopup = useTwoFactorAuthenticationPopup();
    const {
        validationStart, validationDone, isValidationInProcess, areAllValidationsDone
    } = useValidationManager(VALIDATION_TYPE.TWO_FACTOR_AUTHENTICATION, validationsRef);

    return useCallback((pasLoginResponse, credentials, options = {}) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        if (!sessionValidationData.SessionValidationBy2FAData) {
            validationDone();

            return;
        }

        if (isValidationInProcess()) {
            return;
        }

        let ensureLogout = true;

        validationStart();

        showTwoFactorAuthenticationPopup({
            initiator: 'login',
            id: VALIDATION_TYPE.TWO_FACTOR_AUTHENTICATION,
            title: getMessageFromActions(pasLoginResponse),
            onSuccess: async () => {
                validationDone();

                if (areAllValidationsDone()) {
                    await continueLogin({ credentials, ...options });
                }

                ensureLogout = false;
            },
            onClose: async () => {
                if (ensureLogout) {
                    await logout();

                    closePopups({ excludeLayers: [LAYER.LOGIN] });
                }
            },
            resendHandler: resendLogin2FAToken,
            showTrustDeviceOption: sessionValidationData.SessionValidationBy2FAData[0]?.showTrustDeviceOption
        });
    }, [
        logout, continueLogin, showTwoFactorAuthenticationPopup, closePopups,
        validationStart, validationDone, isValidationInProcess, areAllValidationsDone
    ]);
};
